import { FinancialInstitutionEntity } from '../entities/financial-institution-entity';

export default class State {
  items: Array<FinancialInstitutionEntity> = [];
}
